import { css, jsx } from '@emotion/core';
import { Input, Select } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { handleFormChange } from '@/src/register/redux/registerAccountReducer';
import Form from '@/src/shared/components/Form';
import { bp, colors } from '@/styles';

const { Option } = Select;

const styles = {
  inputContainer: css`
    width: 100%;
    margin: 1.6rem 0;
    @media ${bp.md} {
      max-width: 36.5rem;
    }
    .ant-input {
      border-width: 1px;
      border-style: solid;
      border-color: rgb(218, 217, 215);
    }
  `,
  selectContainer: css`
    width: 100%;
    margin: 1.6rem 0;
    @media ${bp.md} {
      max-width: 36.5rem;
    }
  `,
  select: css`
    width: 100%;
    .ant-select-selection {
      background-color: ${colors.accentGrayUltralight};
    }
  `,
};

const OfficeState = props => {
  const { form, info, step, currentInfo, key, onChange } = props;
  const {
    label,
    persist,
    meta,
    field,
    formOverrides = {},
    options = [],
    optionId,
    optionDesc,
  } = info;
  const dispatch = useDispatch();
  const { register } = useSelector(state => state);
  const { isOtherOfficeStateVisible } = register;

  const countryChange = e => {
    if (e === 'Other') {
      dispatch(handleFormChange({ name: 'isOtherOfficeStateVisible', value: true }));
    } else {
      dispatch(handleFormChange({ name: 'isOtherOfficeStateVisible', value: false }));
    }
  };

  useEffect(() => {
    if (register.StateCode === 'Other') {
      props.handleFormChange({ name: 'isOtherOfficeStateVisible', value: true });
    }
  }, []);

  return (
    <>
      <div key={optionId} css={styles.selectContainer}>
        <Form.Item label="State">
          {form.getFieldDecorator('StateCode', {
            initialValue: register['StateCode'],
            rules: [{ required: true, message: 'Select State.' }],
          })(
            <Select
              showSearch
              allowClear
              optionFilterProp="children"
              onChange={e => {
                countryChange(e);
                onChange('StateCode', e);
              }}
              css={styles.select}
              size="large"
              placeholder="Select"
            >
              {options.map(option => (
                <Option key={`Office-StateCode-${optionId}`} value={option[optionId]}>
                  {option[optionDesc]}
                </Option>
              ))}
            </Select>
          )}
        </Form.Item>
      </div>
      {isOtherOfficeStateVisible && (
        <div key={key} css={styles.inputContainer}>
          <Form.Item label="State/Region/Province">
            {form.getFieldDecorator('OfficeStateOther', {
              initialValue: '',
              rules: [{ required: true, message: 'Enter State/Region/Province.' }],
            })(
              <Input
                size="large"
                onChange={e => {
                  onChange('OfficeStateOther', e);
                }}
              />
            )}
          </Form.Item>
        </div>
      )}
    </>
  );
};

export default OfficeState;
